import styled from 'styled-components';
import { media, mediaQuery } from '../../../common/styles/styleUtil';

interface BillboardAdWrapperProps {
  adHeight?: number;
}
interface ShareWrapperProps {
  deviceType?: string;
}
export const ContentMainWrapper = styled.div`
  max-width: 1140px;
  margin: 0 auto;
  padding-top: 32px;
  @media (max-width: 1187px) {
    padding-left: 24px;
    padding-right: 24px;
  }
  @media (${mediaQuery.tablet}) {
    padding: 24px;
    margin: 0;
  }
  ${media.xs`
      padding: 0;
    `};
  &:after {
    display: block;
    clear: both;
    visibility: hidden;
    height: 0;
    overflow: hidden;
    content: '.';
  }
`;

export const ContentLeftWrapper = styled.div`
  width: 100%;
  float: left;
  @media (${mediaQuery.tablet}) {
    float: none;
  }
  .post-video iframe {
    width: 100%;
    height: 421px;
    @media (${mediaQuery.tablet}) {
      height: 405px;
    }
    ${media.xs`
      height: 192px;
    `}
  }
`;

export const ContentLeft = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 390px;
  @media (${mediaQuery.tablet}) {
    margin: 0;
  }
`;

export const ContentRightWrapper = styled.div`
  float: right;
  width: 360px;
  margin-left: -390px;
  @media (${mediaQuery.tablet}) {
    float: none;
    width: 100%;
    margin-left: 0;
  }
`;

export const PageWrapper = styled.div`
  width: 100%;
`;

export const InnerPageWrapper = styled.div`
  width: 100%;
  max-width: 1140px;
  margin: 0 auto;
`;

export const BreadcrumbWrapper = styled.div`
  ${media.xs`
    display: none;
  `}
  .breadcrumb {
    padding: 8px 24px;
    border-bottom: 1px solid #d2d6da;
    font-size: 11px;
    color: #697684;
    line-height: 13px;
    font-weight: 300;
    a {
      height: 13px;
    }
  }
`;

export const Divider = styled.hr`
  clear: both;
  width: 100%;
  margin: 0;
  height: 1px;
  background-color: #d2d6da;
  border: none;
  @media (${mediaQuery.tablet}) {
    width: auto;
    margin: 0 24px;
  }
  ${media.xs`
    margin: 0;
  `}
  &.recommended-divider {
    ${media.xs`
      margin: 0 16px;;
    `}
  }
`;

export const ProjectModuleWrapper = styled.div`
  margin-bottom: 24px;
  padding-top: 16px;
  ${media.xs`
    padding: 16px 16px 0;
  `}
`;

export const ProjectModuleContent = styled.div`
  border-bottom: 1px solid #d2d6da;
`;

export const ShareWrapper = styled.div<ShareWrapperProps>`
  padding-left: 0;
  display: flex;
  padding-top: 13px;
  padding-bottom: 12px;
  ${media.xs`
    padding-left: 16px;
  `}
`;

export const ShareLabelWrapper = styled.p`
  font-size: 16px;
  font-weight: 300;
  margin-top: 0;
  line-height: 24px;
  margin-bottom: 12px;
  padding-top: 4px;
  padding-right: 10px;
`;

export const BillboardAdWrapper = styled.div<BillboardAdWrapperProps>`
  ${(props) => `height: ${props.adHeight}px`};
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ArticlePageLeadsCaptureWrapper = styled.div`
  margin-top: 10px;
  margin-bottom: 10px;
  border-radius: 3px;
  ${media.xs`
    padding: 24px 16px 32px 16px;
    border-left: 0px;
    border-right: 0px;
    border-radius: 0px;
  `}
`;

export const DisclaimerContainer = styled.div`
  margin: 17px auto 24px auto;
  max-width: 1140px;

  @media (max-width: 1187px) {
    padding: 0 24px;
  }

  ${media.xs`
    padding: 0 16px;
  `}
`;
